import http from '../_http'

const agent = {
  //default
  summaryAgent: (m) => { return http.get(`manager/webcastle/agent`, m); },
  listAgent: (m) => { return http.post(`manager/webcastle/agent/list`, m); },
  detailAgent: (m) => { return http.get(`manager/webcastle/agent/${m.id}`); },
  
  //crud
  insertAgent: (m) => { return http.post(`manager/webcatle/agent`, m); },
  updateAgent: (m) => { return http.put(`manager/webcastle/agent`, m); },
  deleteAgent: (m) => { return http.delete(`manager/webcastle/agent/${m.id}`); },

  //domain
  domainAgent: (m) => { return http.get(`manager/webcastle/agent/domain`, m); },

  //crs
  crsAgent: (m) => { return http.post(`manager/webcastle/agent/crs`, m); },
}

export default agent

export { agent }